import React from 'lib/react';
import PropTypes from 'prop-types';
import { EVGrid, EVTypography } from 'lib/components';
import VirtualizedTable from 'commonComponents/virtualizedTable/VirtualizedTable.component';
import useMediaQuery from 'hooks/useMediaQuery';

const TABLE_COLUMNS = [
  { label: 'Report #', dataKey: 'reportId' },
  { label: 'Product type', dataKey: 'productType' },
  { label: 'Delivery', dataKey: 'delivery' },
  { label: 'Address', dataKey: 'address' },
  { label: 'Building ID', dataKey: 'buildingId' },
];

function SitemapSubmittedDetails({ classes, rows }) {
  const isMobile = useMediaQuery(640);

  if (!rows || rows.length === 0) {
    return (
      <EVTypography className={classes.emptyState}>
        No order change details available.
      </EVTypography>
    );
  }

  if (isMobile) {
    return rows.map((row) => (
      <EVGrid
        id={`sitemap-submitted-detail-${row.reportId}`}
        key={`${row.reportId}-${row.buildingId}`}
        className={classes.mobileDetail}
      >
        <EVTypography className={classes.mobileProduct}>{row.productType}</EVTypography>
        <EVTypography className={classes.mobileAddress}>{row.address}</EVTypography>
        <EVGrid container className={classes.mobileRow}>
          <EVGrid>
            <EVTypography>Report #</EVTypography>
            <EVTypography>{row.reportId}</EVTypography>
          </EVGrid>
          <EVGrid>
            <EVTypography>Delivery</EVTypography>
            <EVTypography>{row.delivery}</EVTypography>
          </EVGrid>
          <EVGrid>
            <EVTypography>Building ID</EVTypography>
            <EVTypography>{row.buildingId}</EVTypography>
          </EVGrid>
        </EVGrid>
      </EVGrid>
    ));
  }

  return (
    <VirtualizedTable
      id="sitemap-submitted-order-change-details"
      columns={TABLE_COLUMNS.map((column) => ({
        ...column,
        cellProps: { className: classes.tableCell },
      }))}
      dataList={rows}
      rowKey="reportId"
      headerProps={{ className: classes.tableHeader }}
      className={classes.tableWrap}
    />
  );
}

SitemapSubmittedDetails.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  rows: PropTypes.arrayOf(PropTypes.shape({
    reportId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    productType: PropTypes.string.isRequired,
    delivery: PropTypes.string.isRequired,
    address: PropTypes.string.isRequired,
    buildingId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  })).isRequired,
};

export default SitemapSubmittedDetails;
